import { createSelector } from 'reselect';

export const querySelector = state => state.queryReducer.search;

export const queryInstanceSelector = createSelector(
    state => state.queryReducer,
    (_, props) => props.name,
    (queryReducer, name) => queryReducer.instances[name]
);
